function chartColors () {
  return [
    '#429BFF',
    '#F4B244',
    '#91DA57',
    '#BB6BD9',
    '#DF555D',

    '#8059D2',
    '#FCB4D4',
    '#61D4B8',
    '#FDD835',
    '#FD774D',

    '#4663F3',
    '#FF65A9',
    '#439D57',
    '#AF2A5A'
  ];
}

export default chartColors;
